const flagAircraft = (color) => {
    return `data:image/svg+xml;utf-8, \
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.21 33.36" height="50px" width="50px"><defs><style>.d{fill:%23fff;stroke:${color};stroke-miterlimit:10;stroke-width:1.09px;}.e{fill:${color};}</style></defs><g id="a"/><g id="b"><g id="c"><g><path class="d" d="M13.04,.59h0c6.42,0,11.63,5.21,11.63,11.63v14.6c0,3.3-2.68,5.98-5.98,5.98h0v-8.93l-3.71-.15c-8.47,0-14.43-4.64-14.43-11.82,0-6.47,4.43-11.93,12.49-11.31Z"/><path class="e" d="M21.95,12.47c-.18-5.07-4.44-9.37-9.5-9.61S3.41,6.55,3.59,11.62c0,5.17,4.44,9.37,9.5,9.61l8.88,.13-.03-8.88Z"/></g></g></g></svg>`
}

export default flagAircraft

